import {
  Modal,
  ModalOverlay,
  ModalContent,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsCheckLg, BsFillCheckCircleFill } from "react-icons/bs";

function GetUserVerifiedSubmitSuccessModal({
  showVerificationSumitSuccess,
  setShowVerificationSumitSuccess,
}) {
  const bgColor = useColorModeValue("#fff", "#07182E");

  return (
    <Modal
      isCentered
      isOpen={showVerificationSumitSuccess}
      onClose={() => setShowVerificationSumitSuccess(false)}
    >
      <ModalOverlay />
      <ModalContent bg="transparent">
        <Stack
          maxW="400px"
          alignItems={"center"}
          textAlign={"center"}
          bg={bgColor}
          p="50px 0px"
          borderRadius={"20px"}
        >
          <Stack
            justifyContent={"center"}
            alignItems="center"
            p="20px"
            borderRadius={"50%"}
            w="70px"
            h="70px"
            bg="#32B768"
            mb="20px"
          >
            <BsCheckLg fontSize={"2em"} color={bgColor} />
          </Stack>
          <Text color="#374151" fontSize={"1.2em"} fontWeight={"600"}>
            Under Review
          </Text>
          <Text color="#828282" fontSize=".7em">
            Your verification has been received
            <br /> and it's being reviewed.
          </Text>
        </Stack>
      </ModalContent>
    </Modal>
  );
}

export default GetUserVerifiedSubmitSuccessModal;
